/** Date grouping applied to a pivot date field. */
export enum PivotDateGroupEnum {
  Year = 'Year',
  Quarter = 'Quarter',
  Month = 'Month',
}
